import { IconName } from "@greystar/ui";

type TypePosition = "left" | "right";

type GetLinkIconParams = {
  iconName?: string;
  iconPosition?: string;
  variant?: string;
};

export const isValidIconName = (name: string | undefined): name is IconName => {
  if (!name) return false;
  return true;
};

export const getLinkIcon = ({
  iconName,
  iconPosition,
  variant,
}: GetLinkIconParams = {}):
  | { position: TypePosition; name: IconName }
  | undefined => {
  if (isValidIconName(iconName)) {
    return {
      position: (iconPosition as TypePosition) ?? "right",
      name: iconName,
    };
  }

  if (variant === "tertiary") return undefined;

  return { position: "right", name: "ArrowRight" };
};
